module.exports = __webpack_public_path__ + "img/tick-selected.fa45f55e.svg";